import api from './client'

export async function fetchExpiryItems({ keyword = '', status = '', page = 1, pageSize = 20 } = {}) {
  return api.get('/expiry/items', {
    params: { keyword, status, page, pageSize }
  })
}

export async function getExpiryItem(id) {
  return api.get(`/expiry/items/${id}`)
}

export async function createExpiryItem(payload) {
  return api.post('/expiry/items', payload)
}

export async function updateExpiryItem(id, payload) {
  return api.put(`/expiry/items/${id}`, payload)
}

export async function deleteExpiryItem(id) {
  return api.delete(`/expiry/items/${id}`)
}

export async function batchDeleteExpiryItems(ids) {
  return api.post('/expiry/items/batch-delete', { ids })
}

export async function fetchExpiryStats() {
  return api.get('/expiry/stats')
}

export async function refreshExpiryStatuses() {
  return api.post('/expiry/refresh-statuses')
}

export async function exportExpiryItems({ keyword = '', status = '' } = {}) {
  const response = await api.get('/expiry/export', {
    params: { keyword, status },
    responseType: 'blob'
  })
  return response
}

export async function downloadExpiryTemplate() {
  const response = await api.get('/expiry/template', {
    responseType: 'blob'
  })
  return response
}

export async function printCatenLabel(content) {
  return api.post('/print/caten/label', { content })
}

export async function importExpiryItems(formData) {
  return api.post('/expiry/import', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export async function sendTestReminder(id) {
  return api.post(`/expiry/items/${id}/test-reminder`)
}